import { AsyncPipe, NgStyle } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UserImagePipe } from 'app/core/pipes/user-image.pipe';
import { Observable } from 'rxjs';
import { UserImageService } from 'shared/core/services/user/user-image.service';
import { UserService } from 'shared/core/services/user/user.service';
import { User } from 'shared/interfaces/UserInterface';
@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    imports: [NgStyle, UserImagePipe, AsyncPipe],
})
export class AvatarComponent implements OnInit {
    public image$: Observable<string>;
    public loading: boolean = false;
    public user: User = null;
    constructor(
        private userService: UserService,
        private userImageService: UserImageService
    ) {}

    ngOnInit(): void {
        this.user = this.userService.user;
        this.image$ = this.userImageService.get(this.user.profile_image);
    }
}
